<template>
    <svg class="mark mark--scale" viewBox="0 0 100 100" overflow="visible" data-mark="twirl" aria-hidden="true">
        <ellipse class="twirl__ellipse" cx="50" cy="73.5" rx="8" ry="7.5" />
        <path class="twirl__bowl" d="M26 42 A24 24 0 0 0 74 42 Z" />
        <g class="twirl__diamond">
            <polygon class="twirl__body" stroke-width="2" stroke-linejoin="round" points="50,18 62,30 50,42 38,30" />
        </g>
    </svg>
</template>

<script setup lang="ts"></script>

<style scoped>
@reference "../../../../css/tailwind.css";

@layer components {
    .mark {
        @apply block size-full overflow-visible;
    }

    .mark--scale {
        @apply scale-125;
        transform-origin: 50% 50%;
    }

    .twirl__ellipse {
        fill: var(--tonal-pink-strong);
    }

    .twirl__bowl {
        fill: var(--tonal-green-base);
        transform-box: fill-box;
        transform-origin: 50% 100%;
        animation: twirl-bowl 1.9s infinite;
    }

    .twirl__diamond {
        transform-box: fill-box;
        transform-origin: 50% 50%;
        animation: twirl-hop 1.9s infinite;
    }

    .twirl__body {
        fill: var(--tonal-purple-strong);
        stroke: var(--tonal-purple-strong);
        transform-box: fill-box;
        transform-origin: 50% 100%;
        animation: twirl-squash 1.9s infinite;
    }
}

@keyframes twirl-hop {
    0%,
    16% {
        transform: translateY(0) rotate(0deg);
        animation-timing-function: cubic-bezier(0.15, 0.7, 0.4, 1);
    }

    48% {
        transform: translateY(-26px) rotate(180deg);
        animation-timing-function: cubic-bezier(0.6, 0, 0.85, 0.5);
    }

    72%,
    100% {
        transform: translateY(0) rotate(360deg);
    }
}

@keyframes twirl-squash {
    0% {
        transform: translateY(0) scale(1, 1);
        animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
    }

    16% {
        transform: translateY(1.4px) scale(1.3, 0.68);
        animation-timing-function: cubic-bezier(0.2, 0.8, 0.4, 1);
    }

    21% {
        transform: translateY(0) scale(0.9, 1.14);
        animation-timing-function: ease-out;
    }

    28%,
    71% {
        transform: translateY(0) scale(1, 1);
    }

    75% {
        transform: translateY(2.4px) scale(1.16, 0.84);
        animation-timing-function: ease-out;
    }

    81% {
        transform: translateY(-1px) scale(0.97, 1.03);
        animation-timing-function: ease-in-out;
    }

    87%,
    100% {
        transform: translateY(0) scale(1, 1);
    }
}

@keyframes twirl-bowl {
    0% {
        transform: scale(1, 1);
        animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
    }

    16% {
        transform: scale(1.06, 0.94);
        animation-timing-function: cubic-bezier(0.2, 0.8, 0.4, 1);
    }

    21% {
        transform: scale(0.96, 1.05);
        animation-timing-function: ease-in-out;
    }

    27% {
        transform: scale(1.01, 0.99);
    }

    32%,
    71% {
        transform: scale(1, 1);
    }

    75% {
        transform: scale(1.08, 0.9);
        animation-timing-function: ease-out;
    }

    81% {
        transform: scale(0.97, 1.04);
        animation-timing-function: ease-in-out;
    }

    87% {
        transform: scale(1.01, 0.99);
    }

    92%,
    100% {
        transform: scale(1, 1);
    }
}

@media (prefers-reduced-motion: reduce) {
    .twirl__diamond,
    .twirl__body,
    .twirl__bowl {
        animation: none;
    }
}
</style>
